var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-time-picker.ts
import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { DateTime } from "luxon";
import { BehaviorController } from "@adornis/chemistry/controllers/behavior-controller";
import { FormField } from "@adornis/forms/form-field";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import "@adornis/forms/x-input";
var ElementsTimePicker = class extends FormField {
  constructor() {
    super(...arguments);
    this.value = new BehaviorController(this, DateTime.now());
  }
  render() {
    if (!this.value.getValue())
      return html` no date given `;
    return xComponents(html`
      <x-flex horizontal space="md">
        <x-input
          flex
          ?disabled=${this.disabled}
          placeholder="hh"
          type="number"
          min="0"
          max="24"
          @value-changed=${(e) => {
      if (e.detail.value && +e.detail.value >= 0 && +e.detail.value < 24 && this.value.getValue() && this.value.getValue()?.get("hour") !== +e.detail.value)
        this.value.next(this._setDate(this.value.value, "hour", +e.detail.value));
    }}
          .value=${this.value.getValue()?.get("hour")}
          @value-picked=${() => this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }))}
        >
        </x-input>
        <x-input
          flex
          ?disabled=${this.disabled}
          placeholder="mm"
          type="number"
          min="0"
          max="59"
          @value-changed=${(e) => {
      if (e.detail.value && +e.detail.value >= 0 && +e.detail.value < 60 && this.value.getValue() && this.value.getValue()?.get("minute") !== +e.detail.value)
        this.value.next(this._setDate(this.value.value, "minute", +e.detail.value));
    }}
          .value=${this._padNumber(this.value.getValue()?.get("minute"))}
          @value-picked=${() => this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }))}
        >
        </x-input>
      </x-flex>
    `);
  }
  _setDate(date, timeMode, value) {
    return date.set({ [timeMode]: value });
  }
  _padNumber(num) {
    if (num === void 0)
      return "00";
    return num < 10 ? "0" + num : num + "";
  }
};
__decorateClass([
  state()
], ElementsTimePicker.prototype, "minTime", 2);
__decorateClass([
  state()
], ElementsTimePicker.prototype, "maxTime", 2);
ElementsTimePicker = __decorateClass([
  customElement("x-time-picker")
], ElementsTimePicker);
export {
  ElementsTimePicker
};
